import ServiceApi from "../ServiceApi";
import ServiceReconciliationFilter from "./ServiceReconciliationFilter";
import ServiceReconciliationMatch from "./ServiceReconciliationMatch";
import UtilResponseException from "../../utils/UtilResponseException";
export default class ServiceReconciliationTransaction {
    static _microserviceName = "free";

    static _requestRouts = {
        toggleRevise: '/transactions/toggle-revise',
        transactionsRemove: '/transactions/remove',
        sendBudget: '/transactions/send-budget',
        postDoneIds: '/transactions/done-ids',
        postApproveIds: '/transactions/approve-ids',
        getTableNotMatchedAp: '/transactions/not-matched-ap',
        changeSupplierStatus: '/transactions/offer-supplier-status',
        exportOfferArchive: '/transactions/export-supplier-archive/'
    };

    static async postIds(filterData = [], type = '', actionAfter = () => {}, actionError = () => {}) {
        return await this._postIds(filterData, type, actionAfter, actionError)
    }

    static async _postIds(filterData, type, actionAfter, actionError) {
        const route = type === 'approved' ? this._requestRouts.postApproveIds : this._requestRouts.postDoneIds;
        filterData = ServiceReconciliationFilter._getFilterBefore(filterData)

        try {
            const {data: res} = await ServiceApi.post(this._microserviceName, route, filterData)
            const transactions = res?.data || []
            actionAfter(transactions)
        } catch (error) {
            console.log(error);
            actionError(error)
        }
    }

    static async toggleRevise(priceId = '') {
        return this._toggleRevise(priceId);
    }

    static async _toggleRevise(priceId = '') {
        const reqBody = this._toggleReviseBefore(priceId);

        try {
            const res = await ServiceApi.post(this._microserviceName, this._requestRouts.toggleRevise, reqBody);
            const {data = {}} = res;
            const {data: dataRevised = {}} = data;
            return dataRevised;
        } catch (error) {
            console.log(error);

            throw new Error(error);
        }
    }

    static _toggleReviseBefore(priceId = '') {
        return {transaction: String(priceId)};
    }

    static async exportOfferArchive(kitId) {
        return this._exportOfferArchive(kitId);
    }

    static async _exportOfferArchive(kitId) {
        try {
            const response = await ServiceApi.post(this._microserviceName, this._requestRouts.exportOfferArchive + kitId);
            const {data = {}} = response;
            const {data: {is_task: isTask = false, result = {}}} = data;
            return {
                isTask,
                result: !isTask ? this._exportOfferArchiveAfter(result) : {}
            };
        } catch (error) {

            if(error.isAxiosError){
                throw new Error(UtilResponseException.getMessage(error));
            }

            throw error;
        }
    }

    static _exportOfferArchiveAfter(result){
        const {
            history: {url = ''},
            success = true,
            error = null
        } = result

        if(!success){
            throw new Error(error)
        }

        return {url}
    }

    static async changeSupplierStatus(kitId = '', priceIds = [], supplierStatus = '') {
        return this._changeSupplierStatus(kitId, priceIds, supplierStatus);
    }

    static async _changeSupplierStatus(kitId = '', priceIds = [], supplierStatus = '') {
        const reqBody = this._changeSupplierStatusBefore(kitId, priceIds, supplierStatus);

        try {
            const response = await ServiceApi.put(this._microserviceName, this._requestRouts.changeSupplierStatus, reqBody);
            const {data = {}} = response;
            const {data: supplierStatusData = {}} = data;
            return supplierStatusData;
        } catch (error) {
            throw new Error(UtilResponseException.getMessage(error));
        }
    }

    static _changeSupplierStatusBefore(kitId = '', priceIds = [], supplierStatus = '') {
        return {
            price_group_id: Number(kitId),
            supplier_status: supplierStatus,
            filter: {
                transactions: priceIds
            }
        };
    }

    static async toggleRevises(priceIds = [], isRevised = false) {
        return this._toggleRevises(priceIds, isRevised);
    }

    static async _toggleRevises(priceIds = [], isRevised = false) {
        const requestBody = this._toggleRevisesBefore(priceIds, isRevised);

        try {
            const res = await ServiceApi.post(this._microserviceName, this._requestRouts.toggleRevise, requestBody);

            const {data = {}} = res;
            const {data: dataRevised = {}} = data;
            return Boolean(dataRevised?.is_revised ?? false);
        } catch (error) {
            console.log(error);

            throw new Error(error);
        }
    }

    static _toggleRevisesBefore(priceIds = [], isRevised = false) {
        const requestBody = {
            transactions: priceIds.map(priceId => String(priceId)),
            is_revised: Boolean(isRevised)
        };

        return requestBody;
    }

    static async transactionsRemove(priceIds = []) {
        return this._transactionsRemove(priceIds);
    }

    static async _transactionsRemove(priceIds = []) {
        const reqBody = this._transactionsRemoveBefore(priceIds);

        try {
            await ServiceApi.post(this._microserviceName, this._requestRouts.transactionsRemove, reqBody);
            return true;
        } catch (error) {
            console.log(error);

            throw new Error(error);
        }
    }

    static _transactionsRemoveBefore(priceIds = []) {
        return {transactions: priceIds.map(priceId => String(priceId))};
    }

    static async sendBudget(filterData = []) {
        return this._sendBudget(filterData);
    }

    static async _sendBudget(filterData = []) {
        const reqBody = this._sendBudgetBefore(filterData);

        try {
            await ServiceApi.post(this._microserviceName, this._requestRouts.sendBudget, reqBody);

            return true;
        } catch (error) {
            throw new Error(UtilResponseException.getMessage(error));
        }
    }

    static _sendBudgetBefore(filterData = []) {
        const {filter = {}} = ServiceReconciliationFilter.getFilterBefore(filterData);

        return {...filter};
    }

    static async getTableNotMatchedAp(page = 0, filterData = []) {
        return this._getTableNotMatchedAp(page, filterData);
    }

    static async _getTableNotMatchedAp(page = 0, filterData = []) {
        const { queryParams, requestBody } = this._getTableNotMatchedApBefore(page, filterData);

        try {
            const responseBody = await ServiceApi.post(this._microserviceName, this._requestRouts.getTableNotMatchedAp, requestBody, { params: queryParams });
            const tableData = ServiceReconciliationMatch._getTableSimilarSidesAfter(responseBody?.data?.data ?? {});

            return tableData;
        } catch (error) {
            console.log(error);
        }
    }

    static _getTableNotMatchedApBefore(page = 0, filterData = []) {
        const queryParams = {
            'page': parseInt(page),
            'per-page': 20
        };
        const requestBody = ServiceReconciliationFilter.getFilterBefore(filterData);

        return { queryParams, requestBody };
    }
}
